import type { AppType, Market } from '@client/modules/app-context/constants';
import { appPlatform, getMixpanel } from '@client/tracking/mixpanel';
import { TrackingButtonName, EventNames, TrackingPageName, TrackingFeature } from '@client/tracking/mixpanel-constants';

export const trackChangePaymentDrawerViewed = (market: Market, appType: AppType) => {
  getMixpanel().track(EventNames.VIEWED_PAGE, {
    Feature: TrackingFeature.ChangePayment,
    Page: TrackingPageName.ONBOARDING,
    Market: market,
    Platform: appType,
    'App platform': appPlatform(),
  });
};

export const trackChangePaymentDrawerCloseButtonClicked = (market: Market, appType: AppType) => {
  getMixpanel().track(EventNames.CLICKED_BUTTON, {
    Feature: TrackingFeature.ChangePayment,
    Page: TrackingPageName.ONBOARDING,
    Button: TrackingButtonName.CLOSE,
    Market: market,
    Platform: appType,
    'App platform': appPlatform(),
  });
};

export const trackChangePaymentDrawerContinueButtonClicked = (market: Market, appType: AppType) => {
  getMixpanel().track(EventNames.CLICKED_BUTTON, {
    Feature: TrackingFeature.ChangePayment,
    Page: TrackingPageName.ONBOARDING,
    Button: TrackingButtonName.CONTINUE,
    Market: market,
    Platform: appType,
    'App platform': appPlatform(),
  });
};
